import React from 'react';
import { Button, ButtonGroup, Tooltip, Zoom } from '@mui/material';
import { CloseOutlined, LocationOn, InfoOutlined } from '@mui/icons-material';
import { rgbaObjToString } from '../../../../../../../components/color/color';
import { precioLista } from '../../../../../../../components/compra/SelectorLugares';
import { useMapaCompra } from '../../../../../../../components/compra/MapaCompra';

const TarifasList = ({
  tarifas,
  cantidad,
  setCantidad,
  asientosSeleccionados,
  setTarifasSeleccionadas,
  handleSeleccionarUbicacion,
  incremento,
  decremento,
  necesitaSeleccionUbicacion,
  getTextoBotonTarifa
}) => {
  const { indice: indiceMapa } = useMapaCompra();

  const ordenarTarifasPorColor = (tarifas) => {
    if (!Array.isArray(tarifas)) return [];

    return [...tarifas].sort((a, b) => {
      try {
        const colorA = typeof a.color === 'string' ? JSON.parse(a.color) : a.color;
        const colorB = typeof b.color === 'string' ? JSON.parse(b.color) : b.color;

        if (colorA.r !== colorB.r) return colorA.r - colorB.r;
        if (colorA.g !== colorB.g) return colorA.g - colorB.g;
        if (colorA.b !== colorB.b) return colorA.b - colorB.b;
        return (colorA.a || 1) - (colorB.a || 1);
      } catch {
        return 0;
      }
    });
  };

  const tarifasOrdenadas = ordenarTarifasPorColor(tarifas);

  return (
    <>
      {tarifasOrdenadas ? (
        tarifasOrdenadas
          .filter(tarifa => {
            const tarifasMenoresOcultas = [702, 703, 704];
            return !tarifasMenoresOcultas.includes(tarifa.id);
          })
          .map((tarifa) => (
            <div
              key={tarifa.id}
              className={`position-relative my-3 ${!tarifa.disponible && "tarifa-disabled"}`}
            >
              <div
                className="barra-tarifas"
                style={{
                  backgroundColor: rgbaObjToString(tarifa.color)
                }}
              />

              <div className="ps-4 d-flex flex-column gap-1">
                <div className="d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex flex-column gap-1">
                    <div className="d-flex align-items-center gap-1">
                      <p className="fw-medium m-0 flex-wrap">
                        {tarifa.concepto}
                      </p>
                      {tarifa.requiere_aprobacion && (
                        <Tooltip
                          arrow
                          TransitionComponent={Zoom}
                          placement="top"
                          title="Esta entrada requiere la aprobación del organizador. Al solicitarla no se envía automáticamente: queda pendiente hasta que la acepten."
                        >
                          <InfoOutlined sx={{ width: "16px", height: "16px", color: "#5656ff", cursor: "help", flexShrink: 0 }} />
                        </Tooltip>
                      )}
                    </div>
                    {!tarifa?.disponible && (
                      <small className="cartel-agotados p-1 rounded">
                        <CloseOutlined fontSize="14px" /> Agotados
                      </small>
                    )}
                  </div>

                  {tarifa?.disponible && (
                    <div className="d-flex flex-column gap-1">
                      {necesitaSeleccionUbicacion(tarifa) ? (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleSeleccionarUbicacion(tarifa)}
                          sx={{
                            color: "#5656ff",
                            borderColor: "#5656ff",
                            fontSize: "12px",
                            whiteSpace: "nowrap"
                          }}
                          startIcon={<LocationOn fontSize="small" />}
                        >
                          {getTextoBotonTarifa(tarifa)}
                        </Button>
                      ) : (
                        <ButtonGroup>
                          <Button
                            translate="no"
                            className="fw-bold"
                            disabled={cantidad[tarifa.id] === 0}
                            onClick={() => decremento(tarifa.id)}
                            sx={{
                              width: "40px",
                              color: "#221a60",
                              borderColor: "#221a60",
                            }}
                            aria-label="restar"
                          >
                            -
                          </Button>
                          <Button
                            translate="no"
                            className="fw-bold"
                            disabled
                            style={{
                              width: "40px",
                              color: "#221a60",
                              borderColor: "#221a60",
                              cursor: "default",
                            }}
                            aria-label={`Cantidad ${cantidad[tarifa.id] || 0}`}
                          >
                            {cantidad[tarifa.id] || 0}
                          </Button>
                          <Button
                            translate="no"
                            className="fw-bold"
                            onClick={() => incremento(tarifa.id)}
                            sx={{
                              width: "40px",
                              color: "#221a60",
                              borderColor: "#221a60",
                            }}
                            aria-label="sumar"
                          >
                            +
                          </Button>
                        </ButtonGroup>
                      )}
                    </div>
                  )}
                </div>

                {tarifa?.disponible && (
                  <div className="d-flex flex-wrap">
                    <p className="fw-medium m-0 d-inline-block">
                      {precioLista(indiceMapa, tarifa).desde && "desde "}${" "}
                      {precioLista(indiceMapa, tarifa).precio.toLocaleString("es-ES", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true,
                      })}{" "}
                    </p>
                    <small className="text-secondary">
                      {" + $ "}
                      {tarifa.costo_servicio.toLocaleString("es-ES", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true,
                      })}{" "}
                      costo del servicio
                    </small>
                  </div>
                )}
              </div>
            </div>
          ))
      ) : (
        <p className="text-center">Aún no hay tarifas.</p>
      )}
    </>
  );
};

export default TarifasList;